import { lng } from '../locales'

export const setupFetchWrapper = () => {
  const originalFetch = window.fetch

  window.fetch = async (...args) => {
    if (!navigator.onLine) {
      throw new Error(lng('errors:apiOffline'))
    }

    try {
      return await originalFetch(...args)
    } catch (error) {
      if (error.message === 'Failed to fetch') {
        throw new Error(lng('errors:apiOffline'))
      }

      throw error
    }
  }
}
